import {
  Button,
  Collapse,
  Empty,
  message,
  Modal,
  Progress,
  Upload,
} from 'antd';
import { EmptyIcon } from 'assets/icon/bigicon';
import { ForwardIcon, LayerIcon, SortIcon } from 'assets/icon';
import { ExportIcon, GalleryIcon, ImportIcon } from 'assets/icon/dynamic';
import MFAImage from 'assets/mfa.png';
import axios from 'axios';
import ModalCategoryForm from 'components/ModalCategoryForm';
import ModalDelete from 'components/ModalDelete';
import ModalFloorForm from 'components/ModalFloorForm';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import {
  createCategory,
  deleteCategory,
  fetchCategories,
  modifyCategory,
  setCategory,
} from 'state/actions/categories';
import {
  createFloor,
  deleteFloor,
  fetchFloor,
  modifyFloor,
  setFloor,
} from 'state/actions/floor';
// import { fetchMaps } from 'state/actions/maps';
import {
  bulkRecovery,
  deletePoi,
  downloadPois,
  fetchPois,
  removePoi,
} from 'state/actions/pois';
import _ from 'underscore';
import { getAccess } from 'utils';
// import { regexInput } from 'utils/regex';
import { url } from 'utils/url';
import Cards from 'design-components/Cards';
import CategoryDropdown from 'components/CategoryDropdown';
import { setPoiCategory, setPoiFloor, setPoiLinkFilter, setPoiTag, setTabTenant } from 'state/actions/breadcrumb';
import {
  createTag,
  deleteTag,
  fetchTags,
  modifyTag,
  setTag,
} from 'state/actions/tag';
import ModalTagForm from 'components/ModalTagForm';
import './Pois.css';
import {
  createSubCategory,
  deleteSubCategory,
  fetchSubCategories,
  modifySubCategory,
  setSubCategory,
} from 'state/actions/subCategories';
import ModalSubCategoryForm from 'components/ModalSubCategoryForm';
import { filterAccess } from 'components/Report/utils';
import ModalConfirmation from '../../components/ModalConfirmation';
import DropdownWrapper from '../../components/DropdownWrapper';
import { CircularProgress } from '@material-ui/core';
import ModalPoiAssets from '../../components/ModalPoiAssets';
import { fetchEditorData } from '../../state/actions/editors';

// const { Option } = Select;
// const { Panel } = Collapse;

function Pois({ history }) {
  const { siteId, siteName } = useParams();

  const {
    poisList,
    selectedCategory,
    selectedTag,
    selectedFloor,
    selectedLinkFilter,
    loading,
    categoriesList,
    // downloading,
    floorList,
    siteList,
    category,
    categoryLoading,
    subCategoryList,
    subCategory,
    subCategoryLoading,
    userData,
    role,
    floor,
    tag,
    tagList,
    floorLoading,
    tagLoading,
    selectedTab,
  } = useSelector(
    (state) => ({
      poisList: state.pois.list,
      siteList: state.sites.list,
      selectedCategory: state.breadcrumb.poiCategory,
      selectedTag: state.breadcrumb.poiTag,
      selectedFloor: state.breadcrumb.poiFloor,
      selectedLinkFilter: state.breadcrumb.poiLinkFilter,
      loading: state.pois.loading,
      // downloading: state.pois.downloading,
      deleted: state.pois.deleted,
      categoriesList: state.categories.list,
      floorList: state.floor.list,
      tagList: state.tags.list,
      category: state.categories.category,
      categoryLoading: state.categories.loading,
      subCategoryList: state.subcategories.list,
      subCategory: state.subcategories.subCategory,
      subCategoryLoading: state.subcategories.loading,
      userData: state.auth.userData,
      role: state.auth.userData.role,
      floor: state.floor.floor,
      tag: state.tags.tag,
      floorLoading: state.floor.loading,
      tagLoading: state.tags.loading,
      selectedTab: state.breadcrumb.tenant,
    }),
    shallowEqual
  );

  const [search, setSearch] = useState();
  // const [floor, setFloor] = useState();
  const [modalUpload, setModalUpload] = useState(false);
  const [modalAssets, setModalAssets] = useState(false);
  const [isDragged, setIsDragged] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [progress, setProgress] = useState(0);
  // const [searchError, setSearchError] = useState(null);
  // const [minValue, setMinValue] = useState(0);
  // const [maxValue, setMaxValue] = useState(16);
  const [tempSelectedCategory, setTempSelectedCategory] =
    useState(selectedCategory);
  const [linkOpen, setLinkOpen] = useState(false);
  const [playlistOpen, setPlaylistOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);
  // const [selectedTab, setSelectedTab] = useState('published');

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState('all');
  const [tempSelectedSubCategory, setTempSelectedSubCategory] =
    useState(selectedSubCategory);
  const [subCategoryOpen, setSubCategoryOpen] = useState(false);

  const [tempSelectedFloor, setTempSelectedFloor] = useState(selectedFloor);
  const [floorOpen, setFloorOpen] = useState(false);

  const [tempSelectedLinkFilter, setTempSelectedLinkFilter] =
    useState(selectedLinkFilter);

  const [tempSelectedTag, setTempSelectedTag] = useState(selectedTag);
  const [tagOpen, setTagOpen] = useState(false);

  const [sortBy, setSortBy] = useState({
    sort: 'name',
    direction: 'asc',
  });
  const [sortByTemp, setSortByTemp] = useState(sortBy);
  const [modalCategory, setModalCategory] = useState(false);
  // const [isEditing, setIsEditing] = useState(false);
  const [modalDeleteCategory, setModalDeleteCategory] = useState({
    show: false,
    category: null,
  });
  const [modalDeleteSubCategory, setModalDeleteSubCategory] = useState({
    show: false,
    subCategory: null,
  });

  // const [isEditingFloor, setIsEditingFloor] = useState(false);
  const [modalSubCategory, setModalSubCategory] = useState(false);
  const [modalFloor, setModalFloor] = useState(false);
  const [modalTag, setModalTag] = useState(false);
  const [, setAccess] = useState(null);
  const [modalDeleteFloor, setModalDeleteFloor] = useState({
    show: false,
    floor: null,
  });
  const [modalDeleteTag, setModalDeleteTag] = useState({
    show: false,
    tag: null,
  });
  const [openModal, setOpenModal] = useState({
    isOpen: false,
    title: '',
    description: '',
    icon: '',
    poiId: [],
    status: 'approved',
  });

  const [deleteModal, setDeleteModal] = useState({
    poisListSorted: null,
    isOpen: false,
  });
  const [selectedPois, setSelectedPois] = useState([]);

  const linkFilters = [
    { _id: 'full', name: 'Linked to Shape' },
    { _id: 'partial', name: 'Partial Linked to Shape' },
    { _id: 'none', name: 'Unlinked to Shape' },
  ];
  const dispatch = useDispatch();
  const uid = userData.id;
  const site = siteList.find((site) => site._id === siteId);

  useEffect(() => {
    dispatch(fetchCategories({ siteId }));
    dispatch(fetchSubCategories({ siteId }));
    dispatch(fetchFloor({ siteId }));
    dispatch(fetchTags({ siteId }));
    if(site.isWayfinding || site.editorSiteId){
      dispatch(fetchEditorData({ siteId:site.editorSiteId })).then(async () =>
        await dispatch(
          fetchPois({ siteId, categoryId: selectedCategory, type: selectedTab })
        )
      );

    } else{
      dispatch(fetchPois({siteId, categoryId:selectedCategory, type:selectedTab}))
    }

  }, [siteId]); // eslint-disable-line

  useEffect(() => {
    if (userData && userData.roleAccess) {
      setAccess(getAccess(userData, 'poi', siteId));
    }
  }, [userData, siteId]); //eslint-disable-line


  useEffect(() => {
    dispatch(
      fetchPois({ siteId, categoryId: selectedCategory, type: selectedTab })
    );
  }, [selectedCategory, selectedTab]); // eslint-disable-line

  const handleDownload = () => {
    dispatch(downloadPois({ siteId, siteName }));
  };

  const onRemoveButtonClickHandler = (poi) => {
    setDeleteModal((prevState) => ({
      poi,
      isOpen: !prevState.isOpen,
    }));
  };

  const onCloseModalHandler = () => {
    setDeleteModal({ poi: null, isOpen: false });
  };

  const onDeletePoiHandler = () => {
    if (selectedTab === 'archived') {
      dispatch(
        deletePoi({ id: deleteModal.poi, siteId }, () => {
          onCloseModalHandler();
        })
      );
    } else {
      dispatch(
        removePoi({ id: deleteModal.poi, siteId }, () => {
          onCloseModalHandler();
        })
      );
    }
  };

  const handleUpload = () => {
    setModalUpload(true);
  };

  const handleAssets = () => {
    setModalAssets(true);
  };

  const onFileChangedHandler = (file) => {
    setIsDragged(false);
    if (
      file.type !== 'application/vnd.ms-excel' &&
      file.type !==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      message.error('File format must be excel/.xlsx!');
    } else {
      setSelectedFile(file); // Only store file
    }
    return false; // prevent Upload from auto-uploading
  };

  const handleSubmitUpload = () => {
    if (!selectedFile) {
      message.error('Please select a file first.');
      return;
    }

    setIsUploaded(true);

    const config = {
      onUploadProgress(progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setProgress(percentCompleted);
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    };

    const data = new FormData();
    data.append('file', selectedFile);
    data.set('siteId', siteId);

    axios
      .post(`${url}/poi/import`, data, config)
      .then((res) => {
        message.success(res.data.message);
        setModalUpload(false);
        dispatch(
          fetchPois({
            siteId,
            categoryId: selectedCategory,
            type: selectedTab,
          })
        );
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
        } else {
          message.error('Server is stopped');
        }
      })
      .finally(() => {
        setIsUploaded(false);
        setSelectedFile(null);
      });
  };
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const poisListSorted =
    sortBy.direction === 'desc'
      ? _.sortBy(poisList, sortBy.sort).reverse()
      : _.sortBy(poisList, sortBy.sort);

  const getPoiFloorIds = (poi) => {
    let ids = poi.floorIds;
    if (typeof ids === 'string') {
      try {
        ids = JSON.parse(ids);
      } catch (e) {
        ids = null;
      }
    }
    if (Array.isArray(ids) && ids.length > 0) return ids;
    return poi.floorId ? [poi.floorId] : [];
  };

  const dataByFloor = poisListSorted.filter((poi) => {
    return selectedFloor !== 'all'
      ? getPoiFloorIds(poi).includes(selectedFloor)
      : true;
  });

  const dataByTag = dataByFloor.filter((poi) => {
    return selectedTag !== 'all' ? poi.tags.includes(selectedTag) : true;
  });

  const dataByLinkFilter = dataByTag.filter((poi) => {
    return selectedLinkFilter !== 'all'
      ? poi.hasShape?.toString() === selectedLinkFilter
      : true;
  });
  const dataBySubcat = selectedSubCategory
    ? dataByLinkFilter.filter((poi) => {
        return selectedSubCategory !== 'all'
          ? poi.subCategoryIds.includes(selectedSubCategory)
          : true;
      })
    : dataByLinkFilter;

  const filteredData = search
    ? dataBySubcat.filter((el) => {
        const clonedElem = { ...el };
        return clonedElem.name.toLowerCase().includes(search.toLowerCase());
      })
    : dataBySubcat;

  const getCategory = (categoryId) => {
    const findCategory = categoriesList.find((cat) => cat._id === categoryId);
    if (!findCategory) dispatch(setPoiCategory('all'));
    return findCategory?.name;
  };

  const getSubCategory = (subCategoryId) => {
    const findCategory = subCategoryList.find(
      (cat) => cat._id === subCategoryId
    );
    return findCategory?.name;
  };

  const handleSetPlaylist = () => {
    dispatch(setPoiCategory(tempSelectedCategory));
    setPlaylistOpen(false);
  };

  const handleEdit = (id) => {
    history.push(`/${siteId}/information/${siteName}/pois/${id}`);
  };

  const getFloor = () => {
    const findFloor = floorList.find((floor) => floor._id === selectedFloor);
    return findFloor?.name;
  };
  const getTag = () => {
    const findTag = tagList.find((tag) => tag._id === selectedTag);
    return findTag?.name;
  };

  const handleSortTemp = (type, value) => {
    setSortByTemp({
      ...sortByTemp,
      [type]: value,
    });
  };

  const handleSort = () => {
    setSortBy(sortByTemp);
    setSortOpen(false);
  };

  const handleSetCategory = (data) => {
    dispatch(setCategory(data));
  };
  const handleSetSubCategory = (data) => {
    dispatch(setSubCategory(data));
  };

  const onSubmitCategory = () => {
    const action = category._id ? modifyCategory : createCategory;

    dispatch(
      action({ ...category, siteId, id: category._id, uid }, () =>
        setModalCategory(false)
      )
    );
  };
  const onSubmitSubCategory = () => {
    const action = subCategory._id ? modifySubCategory : createSubCategory;

    dispatch(
      action(
        {
          ...subCategory,
          siteId,
          categoryId: selectedCategory,
          id: subCategory._id,
          uid,
        },
        () => setModalSubCategory(false)
      )
    );
  };

  const handleEditCategory = (category) => {
    // setIsEditing(true);
    dispatch(setCategory(category, () => setModalCategory(true)));
  };

  const handleEditSubCategory = (subCat) => {
    dispatch(setSubCategory(subCat, () => setModalSubCategory(true)));
  };

  const handleDeleteCategory = (category) => {
    setModalDeleteCategory({
      show: true,
      category,
    });
  };
  const handleDeleteSubCategory = (subCat) => {
    setModalDeleteSubCategory({
      show: true,
      subCategory: subCat,
    });
  };

  const onCloseModalCategoryHandler = () => {
    setModalDeleteCategory({
      show: false,
      category: null,
    });
  };
  const onCloseModalSubCategoryHandler = () => {
    setModalDeleteSubCategory({
      show: false,
      category: null,
    });
  };

  const onDeleteCategory = () => {
    dispatch(
      deleteCategory(modalDeleteCategory.category._id, siteId, () =>
        onCloseModalCategoryHandler()
      )
    );
  };
  const onDeleteSubCategory = () => {
    dispatch(
      deleteSubCategory(modalDeleteSubCategory.subCategory._id, () =>
        onCloseModalSubCategoryHandler()
      )
    );
  };

  const onSubmitFloor = () => {
    const action = floor._id ? modifyFloor : createFloor;

    dispatch(
      action({ uid, ...floor, siteId, id: floor._id }, () =>
        setModalFloor(false)
      )
    );
  };
  const onSubmitTag = (tagSaved) => {
    const action = tag._id ? modifyTag : createTag;

    dispatch(
      action({ uid, ...tagSaved, siteId, id: tag._id }, () => {
        setModalTag(false);
      })
    );
  };

  const handleSetFloor = (data) => {
    dispatch(setFloor(data));
  };
  const handleSetTag = (data) => {
    dispatch(setTag(data));
  };

  const handleSelectedSubCategory = () => {
    setSelectedSubCategory(tempSelectedSubCategory);
    setSubCategoryOpen(false);
  };
  const handleSetFloorCategory = () => {
    dispatch(setPoiFloor(tempSelectedFloor));
    setFloorOpen(false);
  };
  const handleSetTagCategory = () => {
    dispatch(setPoiTag(tempSelectedTag));
    setTagOpen(false);
  };

  const handleEditFloor = (floor) => {
    // setIsEditingFloor(true);
    dispatch(setFloor(floor));
    setModalFloor(true);
  };
  const handleEditTag = (tag) => {
    // setIsEditingFloor(true);
    dispatch(setTag(tag));
    setModalTag(true);
  };

  const handleDeleteFloor = (floor) => {
    setModalDeleteFloor({
      show: true,
      floor,
    });
  };
  const handleDeleteTag = (tag) => {
    setModalDeleteTag({
      show: true,
      tag,
    });
  };

  const onCloseModalFloorHandler = () => {
    setModalDeleteFloor({
      show: false,
      floor: null,
    });
  };
  const onCloseModalTagHandler = () => {
    setModalDeleteTag({
      show: false,
      tag: null,
    });
  };

  const onDeleteFloor = () => {
    dispatch(
      deleteFloor(modalDeleteFloor.floor._id, () => onCloseModalFloorHandler())
    );
  };
  const onDeleteTag = () => {
    dispatch(
      deleteTag({ id: modalDeleteTag.tag._id, siteId }, () =>
        onCloseModalTagHandler()
      )
    );
  };

  const handleCancel = () => {
    dispatch(
      setCategory(
        {
          _id: '',
          name: '',
          description: '',
          siteId: '',
          modifiedAt: new Date().toDateString(),
          modifiedBy: '',
        },
        () => setModalCategory(false)
      )
    );
  };

  const handleSelectPoi = (data) => {
    // if (!copied) {
    const newPois = [...selectedPois];
    const findPois = newPois.find((poi) => poi._id === data._id);
    if (findPois) {
      findPois.isChecked = !findPois.isChecked;
      setSelectedPois(newPois);
    } else {
      setSelectedPois([
        ...selectedPois,
        {
          ...data,
          isChecked: true,
        },
      ]);
    }
    // }
  };
  const handleCancelSubCategory = () => {
    dispatch(
      setSubCategory(
        {
          _id: '',
          name: '',
          description: '',
          siteId: '',
          categoryId: '',
          modifiedAt: new Date().toDateString(),
          modifiedBy: '',
        },
        () => setModalSubCategory(false)
      )
    );
  };

  const handleNew = () => {
    dispatch(
      setCategory(
        {
          _id: '',
          name: '',
          description: '',
          siteId: '',
          modifiedAt: new Date().toDateString(),
          modifiedBy: '',
        },
        () => setModalCategory(true)
      )
    );
  };
  const handleNewSubCategory = () => {
    dispatch(
      setSubCategory(
        {
          _id: '',
          name: '',
          description: '',
          siteId: '',
          categoryId: '',
          modifiedAt: new Date().toDateString(),
          modifiedBy: '',
        },
        () => setModalSubCategory(true)
      )
    );
  };

  const handleNewFloor = () => {
    dispatch(
      setFloor(
        {
          _id: '',
          name: '',
          description: '',
        },
        () => setModalFloor(true)
      )
    );
  };
  const handleNewTag = () => {
    dispatch(
      setTag(
        {
          _id: '',
          name: '',
          logo: null,
          file: null,
        },
        () => setModalTag(true)
      )
    );
  };

  const findSelectedPois = (id) => {
    const findIt = selectedPois.find((poi) => poi._id === id);
    return findIt ? findIt.isChecked : false;
  };
  const handleBulkRecover = () => {
    setOpenModal({
      isOpen: true,
      header: 'POI Recovery',
      title: 'Recover POI',
      description: 'Do you want to recover the POI(s)?',
      mediaId: _.pluck(
        selectedPois.filter((poi) => poi.isChecked),
        '_id'
      ),
      status: false,
      icon: MFAImage,
    });
  };
  const onCloseOpenModalHandler = () => {
    setOpenModal((prevState) => ({
      ...prevState,
      mediaId: [],
      isOpen: false,
    }));
  };
  const handleReset = () => {
    setSelectedPois([]);
    dispatch(
      fetchPois({
        siteId,
        categoryId: selectedCategory,
        type: selectedTab,
      })
    );
  };

  const getShapeTagProps = (poi) => {
    if (role === 'superadmin') {
      if (poi.hasShape === 'full') {
        // Assuming 'hasShape' from previous discussion
        return { tagged: 'Linked to Shape', taggedColor: 'green' };
      }
      if (poi.hasShape === 'partial') {
        // Assuming 'hasShape'
        return { tagged: 'Partially linked to shape', taggedColor: 'yellow' };
      }
      // If it's not 'full' or 'partial', don't return tagged props for superadmin
    }
    return {}; // Return an empty object if conditions are not met
  };

  return (
    <div className="media-library">
      <ModalCategoryForm
        visible={modalCategory}
        onCancel={handleCancel}
        onCreate={onSubmitCategory}
        category={category}
        setCategory={handleSetCategory}
        isEditing={!!category._id}
      />
      <ModalSubCategoryForm
        visible={modalSubCategory}
        onCancel={handleCancelSubCategory}
        onCreate={onSubmitSubCategory}
        subCategory={subCategory}
        setSubCategory={handleSetSubCategory}
        isEditing={!!subCategory._id}
      />

      <ModalFloorForm
        visible={modalFloor}
        onCancel={() => {
          setModalFloor(false);
        }}
        onCreate={onSubmitFloor}
        floor={floor}
        setFloor={handleSetFloor}
        isEditing={!!floor._id}
      />
      <ModalTagForm
        visible={modalTag}
        onCancel={() => {
          setModalTag(false);
        }}
        onCreate={onSubmitTag}
        tag={tag}
        setTag={handleSetTag}
        isEditing={!!tag._id}
      />

      <ModalDelete
        isVisible={deleteModal.isOpen}
        onOk={onDeletePoiHandler}
        onCancel={onCloseModalHandler}
        title="Delete Tenant"
        subtitle={deleteModal.poi ? deleteModal.poi.name : ''}
        loading={loading}
      />

      <ModalDelete
        isVisible={modalDeleteCategory.show}
        onOk={onDeleteCategory}
        onCancel={onCloseModalCategoryHandler}
        title="Delete Category"
        subtitle={
          modalDeleteCategory.category ? modalDeleteCategory.category.name : ''
        }
        loading={categoryLoading}
      />

      <ModalDelete
        isVisible={modalDeleteSubCategory.show}
        onOk={onDeleteSubCategory}
        onCancel={onCloseModalSubCategoryHandler}
        title="Delete Sub Category"
        subtitle={
          modalDeleteSubCategory.subCategory
            ? modalDeleteSubCategory.subCategory.name
            : ''
        }
        loading={subCategoryLoading}
      />

      <ModalDelete
        isVisible={modalDeleteFloor.show}
        onOk={onDeleteFloor}
        onCancel={onCloseModalFloorHandler}
        title="Delete Floor"
        subtitle={modalDeleteFloor.floor ? modalDeleteFloor.floor.name : ''}
        loading={floorLoading}
      />
      <ModalDelete
        isVisible={modalDeleteTag.show}
        onOk={onDeleteTag}
        onCancel={onCloseModalTagHandler}
        title="Delete Tag"
        subtitle={modalDeleteTag.tag ? modalDeleteTag.tag.name : ''}
        loading={tagLoading}
      />

      <ModalPoiAssets
        siteId={siteId}
        open={modalAssets}
        onClose={() => setModalAssets(false)}
      />
      <ModalConfirmation
        title={openModal.title}
        onCloseHandler={onCloseOpenModalHandler}
        header={openModal.header}
        onConfirmHandler={() =>
          dispatch(
            bulkRecovery(
              {
                status: openModal.status,
                ids: _.pluck(
                  selectedPois.filter((poi) => poi.isChecked),
                  '_id'
                ),
                siteId,
              },
              () => {
                handleReset();
                setOpenModal((prevState) => ({
                  ...prevState,
                  poiId: [],
                  isOpen: false,
                }));
              }
            )
          )
        }
        description={openModal.description}
        visible={openModal.isOpen}
        icon={openModal.icon}
      />

      <Modal
        footer={false}
        onCancel={() => {
          setModalUpload(false);
          setIsUploaded(false);
        }}
        visible={modalUpload}
        title="Import Tenant"
        className="modal-poi-upload adsign-modal"
        closeIcon={<i className="feather-x" />}
      >
        <div className="import-template-tip">
          <span role="img" aria-label="document">
            📄
          </span>{' '}
          Don’t have the template? Use <strong>Export Tenant</strong> to get the
          correct file format for importing POIs.
        </div>
        <Collapse defaultActiveKey={['1']}>
          <Collapse.Panel header="Import Rules" key="1">
            <ul>
              <li>
                To add a new POI, leave the <strong>id</strong> column empty.
              </li>
              <li>
                Columns that can have multiple values:{' '}
                <strong>subcategory</strong> and <strong>tags</strong>. Separate
                values using <code>;</code>
              </li>
              <li>
                To update an existing POI, just change any other field. The{' '}
                <strong>ID</strong> column will already be filled in —{' '}
                <strong>leave it unchanged</strong>.
              </li>
            </ul>
          </Collapse.Panel>
        </Collapse>
        {isUploaded ? (
          <div className="upload-loading">
            <p>
              <i className="mdi mdi-loading mdi-spin" />
              Uploading...
            </p>
            <Progress percent={progress} />
          </div>
        ) : (
          <div className="upload-wrapper">
            <p>Upload</p>
            <Upload
              showUploadList={false}
              beforeUpload={onFileChangedHandler}
              style={{ width: '100%' }}
            >
              <div
                onDragLeave={() => setIsDragged(false)}
                onDragOver={() => setIsDragged(true)}
                className={`modal-drop upload-drag-and-drop  ${
                  isDragged ? 'active' : ''
                }`}
              >
                <ExportIcon size={22} color="#C2C2C2" />
                <p className="upload-title">
                  Drag or <span className="upload-highlight">Browse</span>
                </p>
                <p className="upload-subtitle">
                  File format supported: xlsx (Up to 50MB)
                </p>
              </div>
            </Upload>

            {selectedFile && (
              <div style={{ marginTop: 16 }}>
                <p>
                  Selected file: <strong>{selectedFile.name}</strong>
                </p>
                <Button type="primary" onClick={handleSubmitUpload}>
                  Submit
                </Button>
              </div>
            )}
          </div>
        )}
      </Modal>

      <div className="media-header">
        <div className="media-header-left">
          <div className="searchbar-wrapper">
            <div className="searchbar">
              <i className="feather-search" />
              <input
                placeholder="Search"
                className="search-input"
                value={search}
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className="actions__wrapper">
          {/* <Button
            type="danger"
            className="btn btn-danger media__delete"
            onClick={onDeleteButtonHandler}
          >
            Delete Media
          </Button> */}
          {selectedPois.filter((media) => media.isChecked).length > 0 ? (
            <div className="btn-group">
              {selectedTab === 'archived' && (
                <>
                  <button
                    className="btn-outline-primary"
                    onClick={handleBulkRecover}
                  >
                    {/* <TrashIconDanger size={18} color="#CB3A31" /> */}
                    Recover
                  </button>
                </>
              )}
              {/*<button className="btn-outline-danger" onClick={handleBulkDelete}>*/}
              {/*  <TrashIconDanger size={18} color="#CB3A31" />*/}
              {/*  Delete Selected*/}
              {/*</button>*/}
            </div>
          ) : (
            <>
              {
                <button
                  className="btn-outline-secondary"
                  onClick={handleAssets}
                >
                  <GalleryIcon color="#2C82F6" size={18} />
                  Poi Assets
                </button>
              }

              <button className="btn-outline-primary" onClick={handleUpload}>
                <ImportIcon color="#64D5D2" size={18} />
                Import Tenant
              </button>

              <button className="btn-outline-primary" onClick={handleDownload}>
                <ExportIcon color="#64D5D2" size={18} />
                Export Tenant
              </button>
              {(role !== 'superadmin' ||
                filterAccess({
                  userData,
                  siteId,
                  param: 'poi',
                  action: 'create',
                })) && (
                <Link
                  to={`/${siteId}/information/${siteName}/pois/new`}
                  className="btn-primary"
                >
                  <i className="feather-plus mr-2" />
                  New Tenant
                </Link>
              )}
            </>
          )}
        </div>
      </div>

      <div className="media-header">
        <div className="media-header-left">
          <div
            className="playlist-wrapper"
            onClick={() => setPlaylistOpen(!playlistOpen)}
          >
            <div className="playlist-selection">
              <ForwardIcon />
              <span>
                {selectedCategory === 'all'
                  ? 'All Categories'
                  : getCategory(selectedCategory)}
              </span>
            </div>
            <i
              className={`feather-chevron-down ${
                playlistOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={categoriesList}
              setTempSelectedCategory={(id) => setTempSelectedCategory(id)}
              handleEditCategory={
                filterAccess({
                  userData,
                  siteId,
                  param: 'category',
                  action: 'update',
                })
                  ? (cat) => handleEditCategory(cat)
                  : null
              }
              handleDeleteCategory={
                filterAccess({
                  userData,
                  siteId,
                  param: 'category',
                  action: 'delete',
                })
                  ? (cat) => handleDeleteCategory(cat)
                  : null
              }
              modalOpen={playlistOpen}
              handleSetPlaylist={handleSetPlaylist}
              tempSelectedCategory={tempSelectedCategory}
              handleNew={
                filterAccess({
                  userData,
                  siteId,
                  param: 'category',
                  action: 'create',
                })
                  ? handleNew
                  : null
              }
              filter
            />
          </div>
          {selectedCategory !== 'all' && (
            <div
              className="playlist-wrapper"
              onClick={() => setSubCategoryOpen(!subCategoryOpen)}
            >
              <div className="playlist-selection">
                <ForwardIcon />
                <span>
                  {selectedSubCategory === 'all'
                    ? 'All Sub Categories'
                    : getSubCategory(selectedSubCategory)}
                </span>
              </div>
              <i
                className={`feather-chevron-down ${
                  subCategoryOpen ? 'playlist-open' : 'playlist-closed'
                }`}
              />

              <CategoryDropdown
                categories={subCategoryList.filter(
                  (sub) => sub.categoryId === selectedCategory
                )}
                setTempSelectedCategory={(id) => setTempSelectedSubCategory(id)}
                handleEditCategory={
                  role === 'superadmin'
                    ? (cat) => handleEditSubCategory(cat)
                    : null
                }
                handleDeleteCategory={
                  role === 'superadmin'
                    ? (cat) => handleDeleteSubCategory(cat)
                    : null
                }
                modalOpen={subCategoryOpen}
                title="Sub Category"
                handleSetPlaylist={handleSelectedSubCategory}
                tempSelectedCategory={tempSelectedSubCategory}
                handleNew={handleNewSubCategory}
                filter
              />
            </div>
          )}

          <div
            className="playlist-wrapper"
            onClick={() => setSortOpen(!sortOpen)}
          >
            <div className="playlist-selection">
              <SortIcon />
              <span>Sort By</span>
            </div>
            <i
              className={`feather-chevron-down ${
                sortOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <div
              className={`playlist-dropdown ${
                sortOpen ? 'playlist-dropdown-open' : 'playlist-dropdown-closed'
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              <ul>
                <li>
                  <div
                    className="radio"
                    onClick={() => handleSortTemp('sort', 'name')}
                  >
                    {sortByTemp.sort === 'name' && (
                      <div className="radio-checked" />
                    )}
                  </div>
                  Name
                </li>
                <li>
                  <div
                    className="radio"
                    onClick={() => handleSortTemp('sort', 'location')}
                  >
                    {sortByTemp.sort === 'location' && (
                      <div className="radio-checked" />
                    )}
                  </div>
                  Unit Number
                </li>
                <li className="divider" />
                <li>
                  <div
                    className="radio"
                    onClick={() => handleSortTemp('direction', 'asc')}
                  >
                    {sortByTemp.direction === 'asc' && (
                      <div className="radio-checked" />
                    )}
                  </div>
                  Ascending
                </li>
                <li>
                  <div
                    className="radio"
                    onClick={() => handleSortTemp('direction', 'desc')}
                  >
                    {sortByTemp.direction === 'desc' && (
                      <div className="radio-checked" />
                    )}
                  </div>
                  Descending
                </li>
                <li className="playlist-button" onClick={handleSort}>
                  Sort
                </li>
              </ul>
            </div>
          </div>

          <div
            className="playlist-wrapper"
            onClick={() => setFloorOpen(!floorOpen)}
          >
            <div className="playlist-selection">
              <LayerIcon />
              <span>{selectedFloor === 'all' ? 'All Floor' : getFloor()}</span>
            </div>
            <i
              className={`feather-chevron-down ${
                floorOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={floorList}
              setTempSelectedCategory={(id) => setTempSelectedFloor(id)}
              handleEditCategory={
                filterAccess({
                  userData,
                  siteId,
                  param: 'floor',
                  action: 'edit',
                })
                  ? (cat) => handleEditFloor(cat)
                  : null
              }
              handleDeleteCategory={
                filterAccess({
                  userData,
                  siteId,
                  param: 'floor',
                  action: 'delete',
                })
                  ? (cat) => handleDeleteFloor(cat)
                  : null
              }
              modalOpen={floorOpen}
              handleSetPlaylist={handleSetFloorCategory}
              tempSelectedCategory={tempSelectedFloor}
              handleNew={
                filterAccess({
                  userData,
                  siteId,
                  param: 'floor',
                  action: 'create',
                })
                  ? () => handleNewFloor()
                  : null
              }
              filter
              title="Floor"
            />
          </div>
          <div
            className="playlist-wrapper"
            onClick={() => setTagOpen(!tagOpen)}
          >
            <div className="playlist-selection">
              <LayerIcon />
              <span>{selectedTag === 'all' ? 'All Tags' : getTag()}</span>
            </div>
            <i
              className={`feather-chevron-down ${
                tagOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={tagList}
              setTempSelectedCategory={(id) => setTempSelectedTag(id)}
              handleEditCategory={
                filterAccess({
                  userData,
                  siteId,
                  param: 'tag',
                  action: 'update',
                })
                  ? (cat) => handleEditTag(cat)
                  : null
              }
              handleDeleteCategory={
                filterAccess({
                  userData,
                  siteId,
                  param: 'tag',
                  action: 'delete',
                })
                  ? (cat) => handleDeleteTag(cat)
                  : null
              }
              modalOpen={tagOpen}
              handleSetPlaylist={handleSetTagCategory}
              tempSelectedCategory={tempSelectedTag}
              handleNew={
                filterAccess({
                  userData,
                  siteId,
                  param: 'tag',
                  action: 'create',
                })
                  ? () => handleNewTag()
                  : null
              }
              filter
              title="Tag"
            />
          </div>

          {role === 'superadmin' && site.editorSiteId && (
            <DropdownWrapper
              setIsOpen={setLinkOpen}
              isOpen={linkOpen}
              label={'Link Shape Filter'}
              getItemLabel={() =>
                linkFilters.find((link) => link._id === selectedLinkFilter)
                  ?.name
              }
              selectedItem={selectedLinkFilter}
            >
              <CategoryDropdown
                categories={linkFilters}
                setTempSelectedCategory={(catId) =>
                  setTempSelectedLinkFilter(catId)
                }
                handleSetPlaylist={() => {
                  dispatch(setPoiLinkFilter(tempSelectedLinkFilter));
                  setLinkOpen(false);
                }}
                tempSelectedCategory={tempSelectedLinkFilter}
                modalOpen={linkOpen}
                filter
                title={'Link Filter'}
              />
            </DropdownWrapper>
          )}
        </div>
      </div>
      <div className="media-content-wrapper">
        <div className="media-content">
          <div className="media-tab-wrapper">
            <div className="media-tab-left">
              <div
                onClick={() => dispatch(setTabTenant('published'))}
                className={`media-tab ${
                  selectedTab === 'published' ? 'active' : ''
                }`}
              >
                Active Tenants
              </div>
              <div
                onClick={() => dispatch(setTabTenant('unpublished'))}
                className={`media-tab ${
                  selectedTab === 'unpublished' ? 'active' : ''
                }`}
              >
                Unpublished Tenants
              </div>
              <div
                onClick={() => dispatch(setTabTenant('archived'))}
                className={`media-tab ${
                  selectedTab === 'archived' ? 'active' : ''
                }`}
              >
                Removed Tenants
              </div>
            </div>
            Showing {filteredData.length} of {poisList.length} results
          </div>
          <div className="media-list-content">
            {loading && (
              <div className={'media-empty'}>
                <CircularProgress />
              </div>
            )}
            {!loading && filteredData.length > 0 && filteredData.length > 0
              ? _.chunk(filteredData, 3).map((chunk, index) => {
                  return (
                    <div className="media-list-chunk" key={index}>
                      {chunk.map((poi) => {
                        return (
                          <div
                            key={poi._id}
                            data-id={poi._id}
                            className="media-list"
                            onClick={() => handleSelectPoi(poi)}
                          >
                            {findSelectedPois(poi._id) && (
                              <div className="media-overlayed">
                                <div className="media-overlayed-check">
                                  <i className="feather-check" />
                                </div>
                              </div>
                            )}
                            <Cards
                              data={poi}
                              type="tenant"
                              {...getShapeTagProps(poi)}
                              isShowMedia
                              editAction={() => handleEdit(poi._id)}
                              deleteAction={() =>
                                onRemoveButtonClickHandler(poi._id)
                              }
                            />
                          </div>
                        );
                      })}
                      {chunk.length < 2 && <div className="media-list-empty" />}
                      {chunk.length < 3 && <div className="media-list-empty" />}
                    </div>
                  );
                })
              : !loading && (
                  <div className="media-empty">
                    <Empty image={<EmptyIcon/>} description="No Tenant" />
                  </div>
                )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pois;
